import React, { Fragment } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';

import {
    Avatar, Box,
    Button,
    Checkbox,
    colors,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    Icon,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Switch,
    TextField,
    Typography
} from '@material-ui/core';

import { BsFillPersonFill } from "react-icons/bs";
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import { MdGroup } from "react-icons/md";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 400,
        minHeight: 400,
        padding: 20
    },
    treeviewleft: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 350,
        minHeight: 350,
        padding: 20
    },
    treeviewright: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 287,
        minHeight: 287,
        padding: 20
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    rooticon: {
        width: 24,
        height: 24,
        marginRight: theme.spacing(2)
    },
}));

const lista = [];

const Create = ({ item, closeEdition, updateValues, open, groups, messages, templates, checked, handleToggle }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg">
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Notificação
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape({
                                    name: Yup.string().max(255).required('Nome é obrigatório'),
                                    template: Yup.string().max(255).required('Tipo de notificação é o obrigatória'),
                                })
                            }
                            onSubmit={(values, formik) => {
                                values.mailto = checked;
                                updateValues(values);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (
                                <form onSubmit={handleSubmit}>


                                    <Grid
                                        container
                                        spacing={2}
                                    >

                                        <Grid
                                            item
                                            md={6}
                                            xs={6}>

                                            <Grid
                                                container
                                                spacing={1}
                                            >
                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.name && errors.name)}
                                                        fullWidth
                                                        helperText={touched.name && errors.name}
                                                        label="Nome"
                                                        rows={2}
                                                        multiline
                                                        margin="normal"
                                                        name="name"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.name}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={6}
                                                    xs={12}>

                                                    <TextField
                                                        id="outlined-select-currency-native"
                                                        select
                                                        SelectProps={{
                                                            native: true,
                                                        }}
                                                        error={Boolean(touched.template && errors.template)}
                                                        fullWidth
                                                        helperText={touched.template && errors.template}
                                                        label="Tipo"
                                                        margin="normal"
                                                        name="template"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.template}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    >
                                                        {templates.map((option) => (
                                                            <option key={option.name} value={option.name}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </TextField>

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={6}
                                                    xs={12}>
                                                    <Typography
                                                        color="textPrimary"
                                                        gutterBottom
                                                        variant="h6"
                                                    >
                                                        Habiltar envio de notificações
                                                    </Typography>
                                                    <Switch
                                                        checked={values.enabled}
                                                        onChange={handleChange}
                                                        name="enabled" />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>

                                                    <Typography
                                                        color="textPrimary"
                                                        gutterBottom
                                                        variant="h6"
                                                    >
                                                        Canais de envio de mensagem
                                                    </Typography>
                                                    <FormControlLabel
                                                        control={(
                                                            <Checkbox onChange={handleChange} name="toEmail" checked={values.toEmail} />
                                                        )}
                                                        label="Email"
                                                    />
                                                    <FormControlLabel
                                                        control={<Checkbox onChange={handleChange} name="toWhatsApp" checked={values.toWhatsApp} />}
                                                        label="Whatsapp"
                                                    />
                                                    <FormControlLabel
                                                        control={(
                                                            <Checkbox onChange={handleChange} name="toSMS" checked={values.toSMS} disabled />
                                                        )}
                                                        label="SMS"
                                                    />
                                                    <FormControlLabel
                                                        control={(
                                                            <Checkbox onChange={handleChange} name="toTelegram" checked={values.toTelegram} disabled />
                                                        )}
                                                        label="Telegram"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <Typography
                                                        color="textPrimary"
                                                        gutterBottom
                                                        variant="h6"
                                                    >
                                                        Assinantes por equipes, que serão notificados
                                                    </Typography>
                                                    <Paper variant="outlined" >

                                                        <TreeView
                                                            rounded className={classes.treeviewleft}
                                                            defaultCollapseIcon=
                                                            {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                            defaultExpandIcon=
                                                            {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                        >

                                                            {groups.map((group, gindex) => {
                                                                return (
                                                                    <TreeItem nodeId={`Group` + gindex} label={`Equipe ` + (gindex + 1) + ' - ' + group.name}>

                                                                        {group.users.map((user, uindex) => {
                                                                            return (

                                                                                <ListItem key={`User` + uindex} >
                                                                                    <ListItemAvatar>
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={BsFillPersonFill} style={{ color: colors.blue[400] }} ></Icon>}
                                                                                        </Avatar>
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText id={user._id} primary={user.firstname + ` ` + user.lastname}
                                                                                        secondary={`Email: [ ` + user.email + ` ]`} />

                                                                                    <ListItemSecondaryAction>
                                                                                        <Checkbox
                                                                                            edge="end"
                                                                                            onChange={handleToggle(user._id, 'user')}
                                                                                            checked={checked.indexOf(user._id) != -1}
                                                                                            inputProps={{ 'aria-labelledby': user._id }}
                                                                                        />
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>

                                                                            );
                                                                        })}

                                                                    </TreeItem>

                                                                );
                                                            })}

                                                        </TreeView>

                                                    </Paper>

                                                </Grid>
                                            </Grid>

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={6}>

                                            <Grid
                                                container
                                                spacing={1}
                                            >
                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <Typography
                                                        color="textPrimary"
                                                        gutterBottom
                                                        variant="h6"
                                                    >
                                                        Só enviar notificações caso ocorram falhas nos testes abaixo
                                                    </Typography>

                                                    <Paper variant="outlined" >

                                                        <TreeView
                                                            rounded className={classes.treeviewright}
                                                            defaultCollapseIcon=
                                                            {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                            defaultExpandIcon=
                                                            {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                        >

                                                            {lista.map((group, gindex) => {
                                                                return (
                                                                    <TreeItem nodeId={`Group` + gindex} label={`Equipe ` + (gindex + 1) + ' - ' + group.name}>

                                                                        {group.users.map((user, uindex) => {
                                                                            return (

                                                                                <ListItem key={`User` + uindex} >
                                                                                    <ListItemAvatar>
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={BsFillPersonFill} style={{ color: colors.blue[400] }} ></Icon>}
                                                                                        </Avatar>
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText id={user._id} primary={user.firstname + ` ` + user.lastname}
                                                                                        secondary={`Email: [ ` + user.email + ` ]`} />

                                                                                    <ListItemSecondaryAction>
                                                                                        <Checkbox
                                                                                            edge="end"
                                                                                            onChange={handleToggle(user._id, 'user')}
                                                                                            checked={checked.indexOf(user._id) != -1}
                                                                                            inputProps={{ 'aria-labelledby': user._id }}
                                                                                        />
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>

                                                                            );
                                                                        })}

                                                                    </TreeItem>

                                                                );
                                                            })}

                                                        </TreeView>

                                                    </Paper>

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>

                                                    <Typography
                                                        color="textPrimary"
                                                        gutterBottom
                                                        variant="h6"
                                                    >
                                                        Não enviar notificação caso ocorram falhas nos testes abaixo
                                                    </Typography>

                                                    <Paper variant="outlined" >

                                                        <TreeView
                                                            rounded className={classes.treeviewright}
                                                            defaultCollapseIcon=
                                                            {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                            defaultExpandIcon=
                                                            {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                        >

                                                            {lista.map((group, gindex) => {
                                                                return (
                                                                    <TreeItem nodeId={`Group` + gindex} label={`Equipe ` + (gindex + 1) + ' - ' + group.name}>

                                                                        {group.users.map((user, uindex) => {
                                                                            return (

                                                                                <ListItem key={`User` + uindex} >
                                                                                    <ListItemAvatar>
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={BsFillPersonFill} style={{ color: colors.blue[400] }} ></Icon>}
                                                                                        </Avatar>
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText id={user._id} primary={user.firstname + ` ` + user.lastname}
                                                                                        secondary={`Email: [ ` + user.email + ` ]`} />

                                                                                    <ListItemSecondaryAction>
                                                                                        <Checkbox
                                                                                            edge="end"
                                                                                            onChange={handleToggle(user._id, 'user')}
                                                                                            checked={checked.indexOf(user._id) != -1}
                                                                                            inputProps={{ 'aria-labelledby': user._id }}
                                                                                        />
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>

                                                                            );
                                                                        })}

                                                                    </TreeItem>

                                                                );
                                                            })}

                                                        </TreeView>

                                                    </Paper>

                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <Box my={1}></Box>

                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained">
                                                    Salvar
                                                </Button>
                                            </Grid>
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeEdition() }}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Create;
